import DispatchConstants from '../../constants/DispatchConstants';

import CurrentProperty from '../../model/CurrentProperty';

const initState = () => CurrentProperty();

const currentProperty = (state = initState(), action = {}) => {
  const { type, payload } = action;

  switch (type) {
    case DispatchConstants.UPDATE_CURRENT_PROPERTY:
      return { ...state, ...payload };

    case DispatchConstants.UPDATE_CURRENT_PROPERTY_BUILDING_ATTRIBUTES:
      return {
        ...state,
        buildingAttributes: {
          ...state.buildingAttributes,
          ...payload,
        },
      };

    case DispatchConstants.UPDATE_CURRENT_PROPERTY_DISPLAY_TOTAL_MONTHLY_PRICE_WITH_FEE:
      return {
        ...state,
        displayTotalMonthlyPriceWithFee: payload,
      };

    case DispatchConstants.UPDATE_CURRENT_PROPERTY_CURRENT_ROOMMATES_DETAILS:
      return {
        ...state,
        roomForRent: {
          ...state.roomForRent,
          currentRoommatesDetails: {
            ...state.roomForRent.currentRoommatesDetails,
            ...payload,
          },
        },
      };

    case DispatchConstants.UPDATE_CURRENT_PROPERTY_CURRENT_PETS: {
      return {
        ...state,
        roomForRent: {
          ...state.roomForRent,
          currentPets: {
            ...state.roomForRent.currentPets,
            ...payload,
          },
        },
      };
    }
    case DispatchConstants.UPDATE_CURRENT_PROPERTY_ROOMMATE_REQUIREMENTS: {
      return {
        ...state,
        roomForRent: {
          ...state.roomForRent,
          roommateRequirements: {
            ...state.roomForRent.roommateRequirements,
            ...payload,
          },
        },
      };
    }
    case DispatchConstants.UPDATE_CURRENT_PROPERTY_RENTAL_PROTECTION:
      return {
        ...state,
        rentalProtection: {
          ...state.rentalProtection,
          ...payload,
        },
      };
    case DispatchConstants.UPDATE_CURRENT_PROPERTY_RENTERS_INSURANCE:
      return {
        ...state,
        rentersInsurance: {
          ...state.rentersInsurance,
          ...payload,
        },
      };
    case DispatchConstants.UPDATE_CURRENT_PROPERTY_FREEMIUM:
      return {
        ...state,
        freemium: {
          ...state.freemium,
          ...payload,
        },
      };
    case DispatchConstants.UPDATE_DATE_EMAIL_VERIFIED:
      return {
        ...state,
        dateEmailVerified: payload,
      };
    case DispatchConstants.UPDATE_RESTRICTIONS: {
      return {
        ...state,
        restrictions: {
          ...state.restrictions,
          ...payload,
        },
      };
    }

    case DispatchConstants.UPDATE_WEB_ANALYTICS:
      return {
        ...state,
        webAnalytics: payload,
      };

    default:
      return state;
  }
};

export default currentProperty;
